var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup19(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 154.358,
    height: 159.352,
    viewBox: "0 0 154.358 159.352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(587.096 -1300.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M515.519,303.789v15.584l-9.232,8.281-4.9,4.393V303.789a3.461,3.461,0,0,1,3.457-3.457h7.219a3.461,3.461,0,0,1,3.457,3.457",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M622.832,375.316a8.026,8.026,0,0,1-7.632,5.252H477.216a8.173,8.173,0,0,1-5.459-14.255l23.9-21.432v0l17.116-15.351,27.983-25.1a8.153,8.153,0,0,1,10.908,0l68.991,61.874a8.023,8.023,0,0,1,2.177,9",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M607.255,386.3v51.7a21.692,21.692,0,0,1-21.692,21.692H570.689a6.439,6.439,0,0,1-6.439-6.439V420.261A10.153,10.153,0,0,0,554.1,410.105H538.318a10.153,10.153,0,0,0-10.153,10.152v32.988a6.439,6.439,0,0,1-6.439,6.439h-14.87a21.7,21.7,0,0,1-21.7-21.7V386.3Z",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup19);
export default __webpack_public_path__ + "static/media/Group19.1849f5b1eb69bd4e5bc01e3ae11fcbf1.svg";
export { ForwardRef as ReactComponent };